export default __webpack_public_path__ + "static/media/img2.b0aba788.svg";